import { CommonFilters } from './common-types';
import { DefaultProductListSort } from '@services/MarppleShop/features/ProductList/type';

/**
 * URL 빌더 공통 유틸리티 클래스
 */
export class UrlBuilderUtils {
  /**
   * 랭킹 페이지 파라미터 생성
   */
  static buildRankingParams(rankType: string, defaultType = 'REALTIME'): Record<string, string | undefined> {
    // REALTIME이 기본값이므로 다른 타입일 때만 파라미터 추가
    if (rankType !== defaultType) {
      return {
        rank_type: rankType === 'WEEKLY' ? 'weekly' : 'monthly',
      };
    }
    return {};
  }

  /**
   * 공통 필터를 URL 파라미터로 변환
   */
  static buildFilterParams(filters: CommonFilters): Record<string, string | undefined> {
    const params: Record<string, string> = {};

    if (filters.cate_list_id !== undefined) {
      params.cate_list_id = String(filters.cate_list_id);
    }

    if (filters.cate_item_id !== undefined) {
      params.cate_item_id = String(filters.cate_item_id);
    }

    if (filters.is_limited === true) {
      params.is_limited = 'true';
    }

    if (filters.without_sold_out === true) {
      params.without_sold_out = 'true';
    }

    return params;
  }

  /**
   * 상품 목록 페이지 파라미터 생성 (필터 + 정렬)
   */
  static buildProductsParams(
    filters: CommonFilters,
    sort?: string,
    defaultSort: DefaultProductListSort = 'popular',
  ): Record<string, string | undefined> {
    const params = this.buildFilterParams(filters);

    // 기본 정렬이 아닌 경우에만 추가
    if (sort && sort !== defaultSort) {
      params.sort = sort;
    }

    return params;
  }
}
